import { Flex, Skeleton, SkeletonCircle, Tbody, Td, Tr } from '@chakra-ui/react';

import { useDocumentSelection } from '@izimi/hooks';

const emptyRows = Array.from(Array.from({ length: 20 }), (_, i) => ({ id: i }));

export const DocumentTableSkeleton = () => {
  const { activeDocumentId } = useDocumentSelection();

  return (
    <Tbody>
      {emptyRows.map((row) => {
        return (
          <Tr key={row.id}>
            <Td display={{ base: 'none', md: 'table-cell' }} />
            <Td>
              <Flex py={2} flexDirection='row' alignItems='center'>
                <SkeletonCircle mr={3} borderRadius={0} />
                <Skeleton height='10px' width={{ base: '100%', md: '80%' }} />
              </Flex>
            </Td>
            <Td display={activeDocumentId ? 'none' : { base: 'none', lg: 'table-cell' }}>
              <Skeleton height='10px' width='80%' />
            </Td>
            <Td display={{ base: 'none', xl: 'table-cell' }}>
              <Skeleton height='10px' width='80%' />
            </Td>
          </Tr>
        );
      })}
    </Tbody>
  );
};
